import { X, Mail, Phone, MapPin } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ScrollArea } from '@/components/ui/scroll-area';

export default function FilterSidebar({ isOpen, onClose, categories, selectedCategory, onCategorySelect, contact }) {
  return (
    <>
      {/* Backdrop */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/30 z-40 transition-opacity"
          onClick={onClose}
          data-testid="sidebar-backdrop"
        />
      )}

      {/* Sidebar */}
      <div
        className={`fixed top-0 right-0 h-full w-80 bg-white shadow-2xl z-50 transform transition-transform duration-300 ease-out ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
        data-testid="filter-sidebar"
      >
        <div className="flex flex-col h-full">
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b">
            <h2 className="text-xl font-bold" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
              Filters & Info
            </h2>
            <Button onClick={onClose} variant="ghost" size="icon" data-testid="close-sidebar-btn">
              <X size={20} />
            </Button>
          </div>

          <ScrollArea className="flex-1">
            <div className="p-6 space-y-8">
              {/* Categories */}
              <div>
                <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-4">
                  Categories
                </h3>
                <div className="space-y-2">
                  <Button
                    onClick={() => onCategorySelect(null)}
                    variant={selectedCategory === null ? 'default' : 'outline'}
                    className="w-full justify-start"
                    style={selectedCategory === null ? { background: '#b8d71b', color: '#1a1a1a' } : {}}
                    data-testid="category-all"
                  >
                    All Projects
                  </Button>
                  {categories.map((cat) => (
                    <Button
                      key={cat.id}
                      onClick={() => onCategorySelect(cat.name)}
                      variant={selectedCategory === cat.name ? 'default' : 'outline'}
                      className="w-full justify-start"
                      style={selectedCategory === cat.name ? { background: '#b8d71b', color: '#1a1a1a' } : {}}
                      data-testid={`category-${cat.slug}`}
                    >
                      {cat.name}
                    </Button>
                  ))}
                </div>
              </div>

              {/* Contact Info */}
              {(contact.email || contact.phone || contact.address) && (
                <div>
                  <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-4">
                    Contact
                  </h3>
                  <div className="space-y-3">
                    {contact.email && (
                      <a
                        href={`mailto:${contact.email}`}
                        className="flex items-center gap-3 text-sm text-gray-700 hover:text-black transition-colors"
                        data-testid="contact-email"
                      >
                        <Mail size={16} style={{ color: '#b8d71b' }} />
                        <span>{contact.email}</span>
                      </a>
                    )}
                    {contact.phone && (
                      <a
                        href={`tel:${contact.phone}`}
                        className="flex items-center gap-3 text-sm text-gray-700 hover:text-black transition-colors"
                        data-testid="contact-phone"
                      >
                        <Phone size={16} style={{ color: '#b8d71b' }} />
                        <span>{contact.phone}</span>
                      </a>
                    )}
                    {contact.address && (
                      <div className="flex items-start gap-3 text-sm text-gray-700" data-testid="contact-address">
                        <MapPin size={16} style={{ color: '#b8d71b' }} className="mt-0.5" />
                        <span>{contact.address}</span>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* Quick Links */}
              <div>
                <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-4">
                  Quick Links
                </h3>
                <div className="space-y-2">
                  <a
                    href="/admin"
                    className="block text-sm text-gray-700 hover:text-black transition-colors"
                    data-testid="admin-link"
                  >
                    Admin Panel
                  </a>
                </div>
              </div>
            </div>
          </ScrollArea>
        </div>
      </div>
    </>
  );
}